import { SELECIONAR_RESERVA_PARA_CRIAR,
   ALTERAR_PEDIDO_RESERVA_CRIADA,
   ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA,
   ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA } from '../../actions/types'

const initialState = null

export default function reducerSelecionarReservaParaCriar (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_RESERVA_PARA_CRIAR: {
      return action.payload;
    }

    case ALTERAR_PEDIDO_RESERVA_CRIADA: {
      const idPedido = action.payload;
      const novaReservaCriada = Object.assign({}, state, { pedidoId: idPedido });
      return novaReservaCriada;
    }

    case ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA:{
      const formaPagamento = action.payload;
      const formasPagamentoDto = state.formasPagamentoDto.map((forma) => {
        if (forma.codigoTipo === formaPagamento.codigoTipo) {
          return Object.assign({}, forma, { situacao: 'PROCESSANDO', habilitado: false });
        } else {
          return Object.assign({}, forma, { habilitado: false });
        }
      });
      const novaReserva = Object.assign({}, state, { formasPagamentoDto });
      return novaReserva;
    }

    case ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA: {
      const { formaPagamento, situacao, habilitado } = action.payload;
      const formasPagamentoDto = state.formasPagamentoDto.map((forma) => {
        if (forma.codigoTipo === formaPagamento.codigoTipo) {
          return Object.assign({}, forma, { situacao, habilitado });
        } else {
          return Object.assign({}, forma, { habilitado: true });
        }
      });
      const novaReserva = Object.assign({}, state, { formasPagamentoDto });
      return novaReserva;
    }

    default: {
      return state
    }
  }
}
